export class PersonalEmailNotAllowedError extends Error {
  constructor(readonly displayMessage?: string) {
    super('Personal email not allowed');
    this.name = 'PersonalEmailNotAllowedError';
    Object.setPrototypeOf(this, PersonalEmailNotAllowedError.prototype);
  }
}